import * as Yup from 'yup';
import { TFunction } from 'react-i18next';
import {
  DOMAIN_PATTERN,
  normalizeDomain,
  NOT_ALLOWED_DOMAINS_PATTERN,
} from '../customDomains.utils';

const customDomainSchema = (t: TFunction) => ({
  domain: Yup.string()
    .transform((value) => normalizeDomain(value ?? ''))
    .matches(DOMAIN_PATTERN, {
      message: t('componentCustomDomains.invalidDomain'),
      excludeEmptyString: true,
    })
    .test(
      'not-allowed-domain',
      t('componentCustomDomains.invalidDomain'),
      (value) => !value || !NOT_ALLOWED_DOMAINS_PATTERN.test(value),
    )
    .required(t('componentCustomDomains.invalidDomain')),
});

export default customDomainSchema;
